import { HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ImpersonationService } from './impersonation.service';

@Injectable()
export class ImpersonationInterceptor {
  constructor(private _impersonation: ImpersonationService) {}

  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const impersonatedUserId = this._impersonation.impersonatedUserId;
    if (impersonatedUserId != null) {
      req = req.clone({
        setHeaders: {
          // eslint-disable-next-line @typescript-eslint/naming-convention
          'x-user-id': impersonatedUserId,
        },
      });
    }
    return next.handle(req);
  }
}
